import types from "./types";

function set_products_action(payload) {
  return { type: types.SET_PRODUCTS, payload };
}

export { set_products_action };

// old
export default {
  get_products_request: (payload) => ({
    type: types.GET_PRODUCTS_REQUEST,
    payload,
  }),
  set_products: set_products_action,
};
